import script from "./GlobalLoadingOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalLoadingOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalLoadingOverlay.vue?vue&type=style&index=0&id=67c71461&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c71461"]])

export default __exports__